import type { BadgeColor, PayoutStatus } from "@/services/types";

export interface PayoutStatusMeta {
  label: string;
  color: BadgeColor;
}

export function payoutStatusMeta(status: PayoutStatus): PayoutStatusMeta {
  switch (status) {
    case "pending_approval":
      return { label: "Awaiting approval", color: "warning" };
    case "approved":
      return { label: "Approved", color: "info" };
    case "partially_disbursed":
      return { label: "Partially paid", color: "warning" };
    case "disbursed":
      return { label: "Disbursed", color: "success" };
    case "reversed":
      return { label: "Reversed", color: "danger" };
    default:
      return { label: status, color: "secondary" };
  }
}

/** Short, scannable status label used inside dense rows. */
export function payoutStatusShort(status: PayoutStatus): string {
  switch (status) {
    case "pending_approval":
      return "Awaiting approval";
    case "partially_disbursed":
      return "Partial";
    default:
      return payoutStatusMeta(status).label;
  }
}